"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const temporary_error_notification_1 = require("../../temporary-error-notification");
class FetchErrorNotificationService {
    constructor(fetchService, notificationService, notificationMessage, errorReporting) {
        this.fetchService = fetchService;
        this.notificationMessage = notificationMessage;
        this.errorReporting = errorReporting;
        this.temporaryErrorNotification = new temporary_error_notification_1.TemporaryErrorNotification(notificationService, {
            debounceMs: 1000
        });
    }
    start() {
        this.temporaryErrorNotification.enable(this.fetchService.notifications, {
            notificationId: 'temporary-fetch-error',
            notificationName: 'temporary-fetch-error',
            notificationFactory: (error) => {
                if (error instanceof Error) {
                    this.errorReporting.sendNonFatalError(`Coding error: we don't expect this type of error here`, error);
                    return null;
                }
                const payload = this.formatError(error);
                return payload;
            }
        });
    }
    formatError(error) {
        const restartMessage = this.notificationT('restart_message');
        switch (error.type) {
            case 'network-error':
                return {
                    title: this.notificationT('network_error.title'),
                    message: this.notificationT('network_error.message'),
                    technicalDetails: ''
                };
            case 'client-error':
                {
                    switch (error.statusCode) {
                        case 401:
                        case 403:
                        case 407:
                            return {
                                title: this.notificationT('access_error.title'),
                                message: restartMessage,
                                technicalDetails: formatStatus(error.statusCode, error.statusText)
                            };
                        case 404:
                            return {
                                title: this.notificationT('not_found_error.title'),
                                message: restartMessage,
                                technicalDetails: formatStatus(error.statusCode, error.statusText)
                            };
                        default:
                            return {
                                title: this.notificationT('unknown_connection_error.title'),
                                message: restartMessage,
                                technicalDetails: formatStatus(error.statusCode, error.statusText)
                            };
                    }
                }
            case 'unknown-response-error':
                return {
                    title: this.notificationT('unknown_connection_error.title'),
                    message: restartMessage,
                    technicalDetails: formatStatus(error.statusCode, error.statusText)
                };
            case 'server-error':
                return {
                    title: this.notificationT('server_error.title'),
                    message: restartMessage,
                    technicalDetails: formatStatus(error.statusCode, error.statusText)
                };
        }
        function formatStatus(code, statusText) {
            return `${code}: ${statusText}`;
        }
    }
    notificationT(suffix) {
        return this.notificationMessage.message(suffix);
    }
    async stop() {
        this.temporaryErrorNotification.disable();
    }
}
exports.FetchErrorNotificationService = FetchErrorNotificationService;
//# sourceMappingURL=fetch-error-notification-service.js.map